var is_mobile = window.matchMedia('all and (max-width: 600px)').matches;
var is_tablet = window.matchMedia('all and (max-width: 1100px)').matches;

$(function () {
	$.fancybox.defaults.hash = false;
	$.fancybox.defaults.animationEffect = "fade";
	$.fancybox.defaults.loop = true;

	setCocktailNav();


	$(window).on('resize', function () {
		is_mobile = window.matchMedia('all and (max-width: 600px)').matches;
		is_tablet = window.matchMedia('all and (max-width: 1100px)').matches;
	});

	SplitPic($('.splitpic-images'))

	$('.js-open-menu').on('click', (e) => {
		let self = $(e.currentTarget)

		self.find('.gamburger').toggleClass('active')
		$('.header-menu').toggleClass('active')
	});

	$('.header-menu .has-child>a').on('click', (e) => {
		let self = $(e.currentTarget)

		if (!is_tablet) return true;

		self.parent().toggleClass('opened')
		self.siblings('.header-menu-sub,ul').slideToggle()
		self.closest('.header-menu-sub__itm').find('>ul').slideToggle()

		return false
	});

	$('.cocktail-accordion__head').on('click', (e) => {
		let self = $(e.currentTarget),
			block = self.parent(),
			content = block.find('.cocktail-accordion__content')

		block.toggleClass("active")

		if (block.hasClass("active")) {
			gsap.to(content, {height: 'auto'})
		} else {
			gsap.to(content, {height: '0'})
		}

		let need_close = block.closest('.cocktail-content-itm').find(".cocktail-accordion").not(block)
		need_close.removeClass("active")
		gsap.to(need_close.find('.cocktail-accordion__content'), {height: '0'})

	});

	$('.accordion__head').on('click', (e) => {
		let self = $(e.currentTarget),
			block = self.parent(),
			content = block.find('.accordion__content')

		block.toggleClass("active")

		if (block.hasClass("active")) {
			gsap.to(content, {height: 'auto'})
		} else {
			gsap.to(content, {height: '0'})
		}

		let need_close = block.closest('.section-faq').find(".accordion").not(block)
		need_close.removeClass("active")
		gsap.to(need_close.find('.accordion__content'), {height: '0'})

	});

	$('.cocktail-nav-itm').on('click', (e) => {
		let self = $(e.currentTarget),
			block = self.closest(".cocktail")

		block.find(".cocktail-nav-itm").removeClass("active");
		self.addClass("active");

		setCocktailNav();

		return false;
	});

	$('.js-case-load-more').on('click', (e) => {
		let self = $(e.currentTarget)
		$('.case-load-more-wrap').hide();
		$('.case-list').addClass("show-all");
	});

	$(document).on('click', '.js-open-modal', function () {
		let href = $(this).attr('href')

		open_modal(href);
	});

	$('.js-close-modal').on('click', function () {
		$(this).closest('.modal').removeClass("active");
	});
	$('.js-close-modal-all').on('click', function () {
		$('.modal').removeClass("active");
	});

	var alredy_open_leave_modal = false;
	if ($('.js-gift-page').length > 0) {
		$('.wrapper').on('mouseleave', (e) => {
			if (alredy_open_leave_modal) return true;

			open_modal("#modal-gift-leave")
			alredy_open_leave_modal = true;
		});
	}

	$('.js-gift-hero-form-submit').on('submit', (e) => {
		let self = $(e.currentTarget)

		self.addClass('result')
		self.find('.gift-hero-email').addClass('result')

		return false;
	});

});

const open_modal = (href) => {
	$(href).addClass("active");
}


const setCocktailNav = () => {
	const content = $('.cocktail-content-itm')
	let index = $('.cocktail-nav-itm.active').parent().index()

	if (!index || index === -1) {
		$('.cocktail-nav-itm').first().addClass("active");
		index = 0;
	}

	content.removeClass("active")
	content.eq(index).addClass("active")
}
